module.exports = __webpack_public_path__ + "hotelKey.png?ec16796d1521e68e1a72f41011596526";